import { Button, Result } from 'antd';
import type { FallbackProps } from 'react-error-boundary';
import { WarningOutlined } from '@ant-design/icons';

const FallbackComponent = ({ error }: FallbackProps) => {
	if (error.name === 'TypeError' && error.message.includes('Failed to fetch dynamically imported module')) {
		window.location.reload();
		return null;
	}
	return (
		<Result
			icon={<WarningOutlined />}
			title="Wystąpił nieznany błąd"
			extra={
			<Button type="primary" onClick={() => window.location.reload()}>
				Odśwież stronę
			</Button>
			}
		/>
	)
};

export default FallbackComponent;
